import { Button, Card, CardContent, Container, Stack, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom'
import { routes } from '../routes'
import ResetPasswordForm from '../../components/auth/resetPasswordForm'
import { useAuth } from '../../hooks/useAuth'
import Errors from '../../components/global/Errors'
import { ApiError } from '../../shared/types/apiError.type'
function GeneratePassword() {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const { resetPassword, isLoading, isError, error } = useAuth()
    let token = searchParams.get('reset-token') as string
    const err = error?.response?.data as ApiError

    const handleResetPassword = async (data: { password: string, token: string }) => {
        try {

            await resetPassword(data)

            navigate(routes.AUTH_ROUTES.LOGIN)

        } catch (error) {

        }
    }

    if (!token) {
        return <Navigate to={routes.AUTH_ROUTES.LOGIN}></Navigate>
    }

    return (
        <Container maxWidth='xs' sx={{ display: 'flex', alignItems: 'start', flexDirection: 'column', gap: 2, justifyContent: 'center', height: '100vh' }}>
            <Card>
                <CardContent>
                    <Stack direction={'column'} spacing={2}>

                        <Typography fontSize={'18px'} variant='h6'>{t('equi:registration:generate_password:title')}</Typography>
                        <Errors isError={isError} error={err}></Errors>
                        <ResetPasswordForm
                            variant='outlined'
                            isLoading={isLoading} onSubmitReset={(password) => handleResetPassword({ password, token })}></ResetPasswordForm>
                        <Button variant='text' size='small' onClick={() => navigate(routes.AUTH_ROUTES.LOGIN)}>{t('registration:back')}</Button>
                    </Stack>
                </CardContent>
            </Card>

        </Container>
    )
}

export default GeneratePassword